<template>
  <div style="position: relative; width: 100%; height: auto">
    <div class="main-news-wrapper">
      <div class="inner" ref="inner">
        <template v-if="latestNews.length > 0">
          <template v-for="(list, index) in latestNews" :key="index">
            <component
              :is="
                list.length !== pageSize
                  ? 'universalList'
                  : index - 1 === -1
                  ? 'defaultBar'
                  : `bar${(index - 1).toString().substr(-1)}`
              "
              :list="list"
              transition-mode="out-in"
            />
          </template>
        </template>
      </div>
      <div
        v-if="show.spinner"
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 44px 0;
        "
        :style="{ height: latestNews.length > 0 ? 'unset' : '80vh' }"
      >
        <div class="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, watch } from "vue";
import AdditionalBar from "@/components/AdditionalBar";
import MainBar from "@/components/media/MainBar";
import FirstBar from "@/components/media/FirstBar";
import SecondBar from "@/components/media/SecondBar";
import ThirdBar from "@/components/media/ThirdBar";
import FourthBar from "@/components/media/FourthBar";
import { useStore } from "vuex";
import { useInfiniteScroll } from "@/utils/infiniteScroll";
import { useLanguage } from "@/utils/language";

export default {
  components: {
    defaultBar: MainBar,

    universalList: AdditionalBar,

    bar0: FirstBar,
    bar1: SecondBar,
    bar2: ThirdBar,
    bar3: FourthBar,

    bar4: FirstBar,
    bar5: SecondBar,
    bar6: ThirdBar,
    bar7: FourthBar,

    bar8: FirstBar,
    bar9: SecondBar
  },
  setup() {
    const store = useStore();
    const inner = ref(null);
    const show = reactive({
      spinner: true
    });

    const { i18n } = useLanguage();

    const scrollEnd = () => {
      show.spinner = false;
    };

    const pageSize = 12;

    const { startInfiniteScroll, loadData } = useInfiniteScroll({
      wrapper: inner,
      retrieve: (load, cb) => {
        store.dispatch("getLatestNews", {
          pageSize,
          cb: () => cb(),
          category: 'media',
          load
        });
      },
      newsCount: computed(() => store.getters.newsCount),
      currentPage: computed(() => store.getters.currentPage),
      pageSize,
      scrollEnd
    });

    const refreshData = () => {
      store.commit("flushArticleState");

      show.spinner = true;
      startInfiniteScroll();
      loadData();
    };

    refreshData();

    watch(() => i18n.global.locale.value, refreshData);

    return {
      inner,
      show,
      pageSize,
      latestNews: computed(() => store.getters.latestNews)
    };
  }
};
</script>

<style lang="scss" scoped>
.main-news-wrapper {
  --width-media: clamp(375px, 95%, 2560px);
  --category-color: #939393;

  width: 100%;
  position: relative;
  .inner {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 3.125rem;
  }
}
</style>
